import { FocusEvent, FC, useEffect } from 'react';
import dayjs from 'dayjs';
import { UiDatepicker, UiInput } from '@frontend/znanie-uikit';

import RegionsSelector from 'components/common/RegionsSelector';

import { upperCaseFirst } from 'utils/helpers';
import { useMediaQueries } from 'hooks/utils/useMediaQueries';

import { AddressInput } from 'graphql/types';

import { IFirstStepForm } from './FirstStepForm.types';

import css from '../../Form.module.scss';

export const FirstStepForm: FC<IFirstStepForm> = ({ formik, user }) => {
  const { isTabletOrDesktop } = useMediaQueries();

  const {
    values,
    errors,
    touched,
    setValues,
    handleChange,
    setFieldTouched,
    setFieldValue,
    handleBlur,
  } = formik;
  const { firstName, lastName, patronymic, birthDate, region } = values;

  const handleDateSelect = (date: Date) => {
    setValues({
      ...values,
      birthDate: date,
    });
  };

  const handleRegionSelect = (region: AddressInput) => {
    setValues({
      ...values,
      region,
    });
  };

  const handleFioBlur = (e: FocusEvent<any>) => {
    const { name, value } = e.target;
    setFieldValue(name, value ? upperCaseFirst(value.trim()) : value);
    handleBlur(e);
  };

  useEffect(() => {
    values.region && setFieldTouched('region', true);
  }, [values.region]);

  return (
    <>
      <div className={css.row}>
        <UiInput
          id="firstName"
          name="firstName"
          autoFocus
          tabIndex={1}
          fluid
          label="Имя*"
          errorLabel={
            touched.firstName && errors.firstName ? errors.firstName : undefined
          }
          placeholder="Укажите имя"
          maxLength={50}
          onChange={handleChange}
          onBlur={handleFioBlur}
          value={firstName}
          disabled={!!user?.firstName}
          inputSize={isTabletOrDesktop ? 'normal' : 'small'}
        />

        <UiInput
          id="lastName"
          name="lastName"
          tabIndex={2}
          fluid
          label="Фамилия*"
          errorLabel={
            touched.lastName && errors.lastName ? errors.lastName : undefined
          }
          placeholder="Укажите фамилию"
          maxLength={50}
          onChange={handleChange}
          onBlur={handleFioBlur}
          value={lastName}
          disabled={!!user?.lastName}
          inputSize={isTabletOrDesktop ? 'normal' : 'small'}
        />
      </div>

      <div className={css.row}>
        <UiInput
          id="patronymic"
          name="patronymic"
          tabIndex={3}
          fluid
          label="Отчество*"
          errorLabel={
            touched.patronymic && errors.patronymic
              ? errors.patronymic
              : undefined
          }
          placeholder="Укажите отчество"
          maxLength={50}
          onChange={handleChange}
          onBlur={handleFioBlur}
          value={patronymic}
          disabled={!!user?.middleName}
          inputSize={isTabletOrDesktop ? 'normal' : 'small'}
        />

        <UiDatepicker
          id="birthDate"
          name="birthDate"
          placeholderText="01.01.2001"
          tabIndex={4}
          dateFormat="dd.MM.yyyy"
          inputLabel="Дата рождения*"
          maxDate={dayjs().subtract(18, 'year').toDate()}
          selected={birthDate ? new Date(birthDate) : null}
          errorLabel={
            touched.birthDate && errors.birthDate ? errors.birthDate : undefined
          }
          onBlur={handleBlur}
          onChange={handleDateSelect}
          disabled={!!user?.birthDate}
          className={css.formInput}
        />
      </div>

      <div className={css.selectInputWrapper}>
        <RegionsSelector
          tabIndex={5}
          id="regionSelect"
          instanceId="regionSelect"
          customLabel="Регион проживания*"
          defaultOption={region}
          onRegionSelect={handleRegionSelect}
          onBlurSelect={() => setFieldTouched('region', true, true)}
          defaultCustomAddress={values.addressDetail}
          onChangeCustomAddress={(value) =>
            setFieldValue('addressDetail', value)
          }
          onBlurCustomAddress={() => setFieldTouched('addressDetail', true)}
          onChangeCustomAddressCheckbox={(checked) =>
            setFieldValue('selectedCustomAddress', checked)
          }
          errorLabel={
            touched.region && errors.region ? errors.region : undefined
          }
          errorLabelCustomAddress={
            touched.addressDetail && errors.addressDetail
              ? errors.addressDetail
              : undefined
          }
          viewCustomAddress
          disabled={!!user?.address}
        />
      </div>
    </>
  );
};
